module.exports = __webpack_public_path__ + "img/PoweredByMeetingHUB.3eb3bf7c.png";